import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ABOUT_IMAGE } from "@/lib/constants";
import { ArrowRight } from "lucide-react";

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.12]);

  return (
    <section
      id="top"
      ref={ref}
      data-testid="hero"
      className="relative h-[100svh] min-h-[600px] w-full overflow-hidden"
    >
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <img
          src={ABOUT_IMAGE}
          alt="WARNRS INDUSTRIES workshop"
          className="w-full h-full object-contain"
        />
      </motion.div>
      {/* legibility overlays */}
      <div className="absolute inset-0 bg-black/10" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/35 to-transparent" />

      <div className="relative z-10 h-full max-w-[1400px] mx-auto pl-0 pr-4 md:pl-1 md:pr-8 flex flex-col justify-end pb-10 md:pb-14">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="flex"
        >
          <a
            href="#book"
            data-testid="hero-book-btn"
            className="group inline-flex items-center justify-center gap-3 bg-hazard text-black px-10 md:px-14 py-6 md:py-7 font-mono text-base md:text-xl tracking-[0.15em] uppercase font-bold hover:bg-white transition-colors"
          >
            Request Service Now
            <ArrowRight size={24} className="group-hover:translate-x-1 transition-transform" />
          </a>
        </motion.div>
      </div>

      {/* scroll hint */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.1 }}
        className="absolute bottom-6 right-6 hidden md:flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] text-zinc-400 uppercase"
      >
        Scroll to explore
        <span className="w-8 h-px bg-zinc-500" />
      </motion.div>
    </section>
  );
};
